export default [
  {
    path: '/webinar-plus/:id/user-request',
    name: 'Admin.WebinarPlus.UserRequest',
    component: () =>
      import (
        '@/views/WebinarPlus/UserRequest.vue'
      ),
    meta: {
      title: 'List User Request Webinar',
    },
  },
  {
    path: '/webinar-plus/requested',
    name: 'Admin.WebinarPlus.Requested',
    component: () =>
      import (
        '@/views/WebinarPlus/Requested.vue'
      ),
    meta: {
      title: 'List Requested Webinar Plus',
    },
  },
]